import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTitle } from '../../hooks';

import { Box, Typography, Grid, MenuItem } from '@mui/material';

import { TextField, Button } from '../../components/common';
import colors from '../../assets/colors';
import { user } from '../../utils/api';
import { tokenUtils } from '../../utils';

export default function DeleteAccount() {
  useTitle('AgroWe-Usuń konto');
  const history = useHistory();
  const [reason, setReason] = useState('');
  const [password, setPassword] = useState('');

  const handleDeleteAccount = () => {
    user
      .deleteUser()
      .then((result) => {
        tokenUtils.clearToken();
        history.push('/account-deleted');
      })
      .catch((err) => {});
  };

  return (
    <Box
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      sx={{ mt: 10, textAlign: 'center' }}
    >
      <Typography sx={{ color: colors.agroweGreen, mb: 3 }}>
        Aby usunąć konto podaj powód oraz wprowadź aktualne hasło.
      </Typography>
      <Grid container direction="column" alignItems="center">
        <TextField
          modalRight
          select
          label="Powód usunięcia konta"
          sx={{ maxWidth: 300 }}
          onChange={(e) => setReason(e.target.value)}
        >
          <MenuItem value="inne">Inne</MenuItem>
        </TextField>
        <TextField
          modalRight
          label="Aktualne hasło"
          sx={{ maxWidth: 300 }}
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          red
          variant="outlined"
          disabled={password.length <= 0}
          onClick={handleDeleteAccount}
        >
          USUŃ KONTO
        </Button>
      </Grid>
    </Box>
  );
}
